var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ae257474c5698303b464e25a0279135ebb728bcd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bcci-site@josephmark"]={id:"ae257474c5698303b464e25a0279135ebb728bcd"};
      